<script lang="ts">
  import { page } from '$app/stores';
  let { children } = $props();
</script>

<nav class="navbar navbar-expand navbar-dark bg-dark px-3 mb-3">
  <span class="navbar-brand">Deslop</span>
  <ul class="navbar-nav">
    <li class="nav-item">
      <a class="nav-link{$page.url.pathname.startsWith('/review') ? ' active' : ''}" href="/review">Review</a>
    </li>
    <li class="nav-item">
      <a class="nav-link{$page.url.pathname.startsWith('/posts') ? ' active' : ''}" href="/posts">Posts</a>
    </li>
    <li class="nav-item">
      <a class="nav-link{$page.url.pathname.startsWith('/browsers') ? ' active' : ''}" href="/browsers">Browsers</a>
    </li>
  </ul>
</nav>

<div class="px-3">
  {@render children()}
</div>
